import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.checkForEditModal()
  }

  checkForEditModal() {
    const urlParams = new URLSearchParams(window.location.search)
    const fundraiseIdToEdit = urlParams.get('open_edit_modal_for')

    if (fundraiseIdToEdit) {
      const editButton = document.querySelector(`#fundraise_${fundraiseIdToEdit} .panel-action-buttons a.remote-modal`)

      if (editButton) {
        editButton.click()

        // Remove the parameter from URL so the modal doesn't open again
        urlParams.delete('open_edit_modal_for')
        const newUrl = this.buildNewUrl(urlParams)
        window.history.replaceState(history.state, '', newUrl)
      }
    }
  }

  buildNewUrl(urlParams) {
    let newUrl = window.location.pathname

    if (urlParams.toString()) {
      newUrl += '?' + urlParams.toString()
    }

    return newUrl
  }
}
